<template>
  <div class="pb-2">
    <div v-if="loading" class="px-2">
      <h3>Loading...........</h3>
    </div>
    <div v-if="!loading">
      <b-row class="px-2 align-items-center section-header-row no-gutters">
        <b-col><h3>Agreement</h3></b-col>
        <b-col cols="2" class="text-right">
          <b-button
          @click="agreementButtonClick()"
          class="main-navigation-button edit_button"
          variant="white"
          btn-color="primary1"
        >
          <img src="img/Edit.png" class="edit-icon" alt="Edit" />
        </b-button>
        </b-col>
      </b-row>
        <b-modal
          title="Agreement"
          header-class="header-nipige-class"
          id="agreementEdit"
          size="md"
          ref="agreementEdit"
          centered
          hide-footer
        >
          <sagreementmodel
            :catalogData="catalogNames"
            :marketListStore="marketListStore"
            :catalogCategoryNames="catalogCategoryNames"
            :catalogCategoryOptionsProp="catalogCategoryOptions"
          >
            <template v-slot:footer-button="data">
              <b-row class="mt-3">
                <b-col md="4" offset-md="4">
                  <b-button
                    class="btn btn-primary-outline"
                    btn-special="primary"
                    @click="AgreeToNext(data.data)"
                    >Update</b-button
                  >
                </b-col>
              </b-row>
            </template>
          </sagreementmodel>
        </b-modal>
      <b-row class="px-2 mt-1">
        <b-col>
          <b-row>
            <b-col md="6">
              <p class="left-text">Category Type :</p>
            </b-col>
            <b-col md="6">
              <p class="right-text">{{ categoryTypeData }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <b-col class="line" md="4">
              <p class="left-text">Catalog :</p>
            </b-col>
            <b-col md="6">
              <p
                class="right-text"
                v-for="items in catalogNames"
                :key="items._id"
              >
                {{ items.name }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import sagreementmodel from "@/components/Partner/PartnerEdit/Agreement";
import { mapGetters } from "vuex";
import currentUserMix from "@/mixins/currentUser";
export default {
  props: ["agreeData"],
  mixins: [currentUserMix],
  components: {
    sagreementmodel,
  },
  data() {
    return {
      catalogNames: [],
      catalogCategoryNames: [],
      catalogCategoryOptions: [],
      sameObjCount: [],
      loading: false,
      marketListStore: [],
    };
  },
  methods: {
    async agreementButtonClick() {
      let dataDomain = this.$currentUserData.catalogInfo;
      if (
        Array.isArray(dataDomain) &&
        dataDomain.length > 0 &&
        dataDomain[0].categoryType != "CATEGORY"
      ) {
        try {
          if (
            Array.isArray(this.catalogNames) &&
            this.catalogNames.length > 0
          ) {
            this.catalogNames.forEach(async (obj) => {
              if (obj.isCategory) {
                if (!this.sameObjCount.includes(obj.parent)) {
                  this.sameObjCount.push(obj.parent);
                  await this.$store
                    .dispatch("catalog/fetchCatalogById", obj.parent)
                    .then((res) => {
                      this.catalogCategoryNames.push(
                        this.$store.getters["catalog/GetCurrentReadCatalog"]
                          .response
                      );
                    });
                  let searchString = `parent=${obj.parent}`;
                  await this.$store.dispatch(
                    "catalog/fetchCatalogList",
                    searchString
                  );
                  this.catalogCategoryOptions.push(
                    ...this.$store.getters["catalog/GetCategoryList"].data
                      .response
                  );
                }
              }
            });
          }
        } catch (error) {
          console.error("Error fetching catalog categories:", error);
        }
        try {
          if (
            this.$store.getters["partner/GetPartnerData"].agreement
              .marketSegment[0].categoryType == "MARKET"
          ) {
            if (
              Array.isArray(this.catalogNames) &&
              this.catalogNames.length > 0
            ) {
              this.catalogNames.forEach(async (obj) => {
                if (obj.isMarket) {
                  let searchStringMarket = `parent=${obj._id}`;
                  await this.$store.dispatch(
                    "catalog/fetchCatalogList",
                    searchStringMarket
                  );
                  this.catalogCategoryOptions.push(
                    ...this.$store.getters["catalog/GetCategoryList"].data
                      .response
                  );
                }
              });
            }
          }
        } catch (error) {
          console.error("Error fetching catalog categories:", error);
        }
      }
      this.$refs["agreementEdit"].show();
    },
    async callCatalogTree() {
      try {
        let dataDomain = this.$currentUserData.catalogInfo;
        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "DOMAIN"
        ) {
          let searchString = `parent=${dataDomain[0].catalogId}`;
          await this.$store.dispatch("catalog/fetchCatalogList", searchString);
          let domainRes = this.$store.getters["catalog/GetCategoryList"];
          this.marketListStore = domainRes.data.response;
        }
        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "MARKET"
        ) {
          dataDomain.forEach(async (obj) => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", obj.catalogId)
              .then((res) => {
                this.marketListStore.push(res.response);
              });
          });
        }
        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "CATEGORY"
        ) {
          dataDomain.forEach(async (obj) => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", obj.catalogId)
              .then((res) => {
                this.catalogCategoryOptions.push(res.response);
              });
          });
        }
        } catch (error) {
          console.error("Error in callCatalogTree:", error);
        }
    },
    AgreeToNext(data) {
      let agreementData = [];
      try {
        if (
          Array.isArray(data.catalogCategory) &&
          data.catalogCategory.length > 0
        ) {
          if (data.fetchCatagoryKey) {
            data.catalogCategory.map((obj) => {
              agreementData.push({
                categoryType: "CATEGORY",
                catalogId: obj._id,
              });
            });
          } else {
            data.catalog.map((obj) => {
              agreementData.push({
                categoryType: data.market.value,
                catalogId: obj._id,
              });
            });
          }
        } else {
          data.catalog.map((obj) => {
            agreementData.push({
              categoryType: data.market.value,
              catalogId: obj._id,
            });
          });
        }
      } catch {
        this.$swal({
          title: "Error",
          text: "Please select market and catalog properly",
          type: "error",
        });
      }
      let agreementPayload = {
        doc: data.doc,
        valid: data.valid,
        marketSegment: agreementData,
      };
      let payload = {
        id: this.partnerAllData._id,
        data: {
          agreement: agreementPayload,
        },
      };
      this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success",
          });
          this.$emit("reload-partner", this.partnerAllData._id);
          this.$root.$emit("bv::hide::modal", "agreementEdit", "#btnShow");
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error",
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
    }),
    categoryTypeData() {
      if (
        Array.isArray(this.agreeData?.marketSegment) &&
        this.agreeData?.marketSegment?.length > 0
      ) {
        return this.agreeData?.marketSegment[0]?.categoryType;
      } else {
        return null;
      }
    },
  },
  async mounted() {
    this.loading = true;
    try {
      if (this.agreeData && this.agreeData.marketSegment) {
        if (
          Array.isArray(this.agreeData.marketSegment) &&
          this.agreeData.marketSegment.length > 0
        ) {
          let storingCatalog = [];
          this.agreeData.marketSegment.forEach(async (el) => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", el.catalogId)
              .then((res) => {
                storingCatalog.push(
                  this.$store.getters["catalog/GetCurrentReadCatalog"].response
                );
              });
          });
          this.catalogNames = storingCatalog;
        }
      }
      await this.callCatalogTree();
    } catch {}
    this.loading = false;
  },
};
</script>
<style scoped>
.left-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  color: #58585b;
}
.right-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
   white-space: nowrap;      /* prevents line break */
    display: inline-block;
    padding-left: 5px; 
}

[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}
[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 39px;
  width: 90px;
  background-color: var(--primary);
  color: white;
}
[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
  margin-left: 10px;
  padding: 0;
}
[btn-special="primary1"] {
  border-radius: 50%;
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -34px;
  }
}
@media (max-width: 576px) {
  .edit_button {
    margin-left: auto;
    display: block;
  }

  .b-col {
    display: flex;
    align-items: center;
  }
}

.line {
  border-left: 1px dashed #c2c2c2;
}

.edit-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
}
</style>

